import Icon from 'common/components/Icon';
import { TestableComponent } from 'common/interfaces';
import React from 'react';
import {
  MainSettingListItem,
  MainSettingsDrawerItemSubtitle,
  MainSettingsDrawerItemTitle,
  SettingItemContent,
  SettingItemIcon
} from './MainSettingsDrawer.styles';

interface Props extends TestableComponent {
  title: string;
  icon?: string;
  subtitle?: string;
}

function SettingsDrawerSettingItem({ icon, title, subtitle, testId }: Props) {
  return (
    <MainSettingListItem data-test-id={testId}>
      {icon && (
        <SettingItemIcon>
          <Icon
            testId={`${testId}-icon`}
            size="large"
            src={icon}
            style={{ filter: 'contrast(6.5)' }}
          />
        </SettingItemIcon>
      )}
      <SettingItemContent>
        <MainSettingsDrawerItemTitle data-test-id={`${testId}-title`}>
          {title}
        </MainSettingsDrawerItemTitle>
        <MainSettingsDrawerItemSubtitle data-test-id={`${testId}-subtitle`}>
          {subtitle}
        </MainSettingsDrawerItemSubtitle>
      </SettingItemContent>
    </MainSettingListItem>
  );
}

export default React.memo(SettingsDrawerSettingItem);
